import ButtonBase from '@material-ui/core/ButtonBase';
import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';
import MyTableCol from 'v2/components/Shared/MyTable/MyTableCol';
import MyTableRow from 'v2/components/Shared/MyTable/MyTableRow';
import Truncate from 'v2/components/Shared/TruncateText';
import { dateMomentFormat } from 'v2/formatters/date';
import { ETicketStatus } from 'v2/interfaces/help';

import type { ITicket } from 'v2/interfaces/help';

interface IProps {
  ticket: ITicket;
  handleHistory: (tickedId: number) => void;
}

const useStyles = makeStyles(() => ({
  icon: {
    fontSize: 20,
  },
}));

const TicketRow = ({ ticket, handleHistory }: IProps) => {
  const classes = useStyles();

  return (
    <MyTableRow key={ticket.id}>
      <MyTableCol screenSizes={{ xs: 12, sm: 1, md: 6, lg: 3 }}>{ticket.id}</MyTableCol>
      <MyTableCol screenSizes={{ xs: 12, sm: 2, md: 6, lg: 3 }}>
        <Truncate count={50} final='...'>
          {ticket.title}
        </Truncate>
      </MyTableCol>
      <MyTableCol screenSizes={{ xs: 6, sm: 2, md: 6, lg: 3 }}>{dateMomentFormat(ticket.created_at, 'DD/MM/YYYY HH:mm')}</MyTableCol>
      <MyTableCol screenSizes={{ xs: 6, sm: 2, md: 6, lg: 3 }}>{dateMomentFormat(ticket.updated_at, 'DD/MM/YYYY HH:mm')}</MyTableCol>
      <MyTableCol screenSizes={{ xs: 6, sm: 2, md: 6, lg: 3 }}>
        {ticket.solved_at ? dateMomentFormat(ticket.solved_at, 'DD/MM/YYYY HH:mm') : '-'}
      </MyTableCol>
      <MyTableCol screenSizes={{ xs: 6, sm: 2, md: 6, lg: 3 }}>{ETicketStatus[ticket.status]}</MyTableCol>
      <MyTableCol action screenSizes={{ xs: 12, sm: 1, md: 6, lg: 3 }}>
        <ButtonBase onClick={() => handleHistory(ticket.id)}>
          <Tooltip title='Visualizar histórico' placement='top'>
            <Icon classes={{ root: classes.icon }}>access_time</Icon>
          </Tooltip>
        </ButtonBase>
      </MyTableCol>
    </MyTableRow>
  );
};

export default React.memo(TicketRow);
